import { OGP } from '@levelworks/shared-backend-api';
import { ExternalFlexPoolsTableColumnDefinition } from './external-flex-pools-table.types';

export const getExternalFlexPoolsTableData = (
  data: OGP.GetWorkersPoolListItemResponseDto[]
): ExternalFlexPoolsTableColumnDefinition[] => {
  return data.map((item) => ({
    id: item.id,
    flexPoolName: item.name,
    serviceAgreementNames: item.serviceAgreements.map((sa) => sa.name),
    activeWorkersCount: item.activeWorkersCount,
  }));
};
